import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { Toaster } from "@/components/ui/sonner";

import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import CareSeekers from "@/pages/CareSeekers";
import CareSeekerDetail from "@/pages/CareSeekerDetail";
import AnchorIntake from "@/pages/AnchorIntake";
import WellnessNotes from "@/pages/WellnessNotes";
import Referrals from "@/pages/Referrals";
import Resources from "@/pages/Resources";
import Outreach from "@/pages/Outreach";
import MaternalWellness from "@/pages/MaternalWellness";
import Tasks from "@/pages/Tasks";
import Reports from "@/pages/Reports";
import Users from "@/pages/Users";
import AuditLog from "@/pages/AuditLog";
import Impact from "@/pages/Impact";
import Appointments from "@/pages/Appointments";
import CareSeekerDirectLink from "@/pages/CareSeekerDirectLink";
import TechSupport from "@/pages/TechSupport";
import Training from "@/pages/Training";
import Integrations from "@/pages/Integrations";
import DocumentTemplates from "@/pages/DocumentTemplates";
import GeoGap from "@/pages/GeoGap";
import RecentlyDeleted from "@/pages/RecentlyDeleted";
import Timesheets from "@/pages/Timesheets";
import PublicHelp from "@/pages/PublicHelp";
import PublicRefer from "@/pages/PublicRefer";
import PortalLogin from "@/pages/portal/PortalLogin";
import PortalLayout from "@/pages/portal/PortalLayout";
import PortalHome from "@/pages/portal/PortalHome";
import PortalAssessment from "@/pages/portal/PortalAssessment";
import PortalAppointments from "@/pages/portal/PortalAppointments";
import PortalRequestHelp from "@/pages/portal/PortalRequestHelp";
import PortalExpired from "@/pages/portal/PortalExpired";
import PublicPartnerApply from "@/pages/PublicPartnerApply";
import PublicAssessment from "@/pages/PublicAssessment";
import PublicContactLead from "@/pages/PublicContactLead";
import PartnerSubmissions from "@/pages/PartnerSubmissions";
import MyAccount from "@/pages/MyAccount";
import AdminVolunteers from "@/pages/AdminVolunteers";
import AdminRoles from "@/pages/AdminRoles";
import AdminRetention from "@/pages/AdminRetention";
import AdminMaintenance from "@/pages/AdminMaintenance";
import ArchitectureDocs from "@/pages/admin/ArchitectureDocs";
import AdminAssessments from "@/pages/AdminAssessments";
import AdminCompliance from "@/pages/AdminCompliance";
import AdminRegulatory from "@/pages/AdminRegulatory";
import AdminEvidence from "@/pages/AdminEvidence";
import AdminExecutiveDashboard from "@/pages/AdminExecutiveDashboard";
import AdminEmailDelivery from "@/pages/admin/AdminEmailDelivery";
import AdminEmailTemplateManager from "@/pages/admin/AdminEmailTemplateManager";
import AdminChangeHistory from "@/pages/admin/AdminChangeHistory";
import ExecutiveOperationsCenter from "@/pages/admin/ExecutiveOperationsCenter";
import AdminPartners from "@/pages/AdminPartners";
import AdminPartnerRecovery from "@/pages/AdminPartnerRecovery";
import PartnerOnboardingWizard from "@/pages/admin/PartnerOnboardingWizard";
import PublicPartnerLockdown from "@/pages/PublicPartnerLockdown";
import PartnerSetPassword from "@/pages/PartnerSetPassword";
import DeveloperPortal from "@/pages/DeveloperPortal";
import TrustCenter from "@/pages/TrustCenter";
import AdminTrustCenter from "@/pages/AdminTrustCenter";
import AdminBackupDisasterRecovery from "@/pages/AdminBackupDisasterRecovery";
import AdminLegalHolds from "@/pages/AdminLegalHolds";
import AdminExceptions from "@/pages/AdminExceptions";
import AdminSsoTenants from "@/pages/AdminSsoTenants";
import IdentitySecurity from "@/pages/IdentitySecurity";
import AdminGovernanceKeys from "@/pages/AdminGovernanceKeys";
import AdminUAT from "@/pages/AdminUATShell";
import TeamCaseload from "@/pages/TeamCaseload";
import AdminFieldCheckins from "@/pages/AdminFieldCheckins";
import SmartInbox from "@/pages/SmartInbox";
import VolunteerLogin from "@/pages/volunteer/VolunteerLogin";
import VolunteerSignup from "@/pages/volunteer/VolunteerSignup";
import VolunteerAcceptInvite from "@/pages/volunteer/VolunteerAcceptInvite";
import VolunteerLayout from "@/pages/volunteer/VolunteerLayout";
import VolunteerHome from "@/pages/volunteer/VolunteerHome";
import VolunteerEvents from "@/pages/volunteer/VolunteerEvents";
import VolunteerHours from "@/pages/volunteer/VolunteerHours";
import VolunteerResources from "@/pages/volunteer/VolunteerResources";
import PartnerLogin from "@/pages/partner/PartnerLogin";
import PartnerAcceptInvite from "@/pages/partner/PartnerAcceptInvite";
import PartnerPortalLayout from "@/pages/partner/PartnerPortalLayout";
import PartnerOverview from "@/pages/partner/PartnerOverview";
import PartnerProfile from "@/pages/partner/PartnerProfile";
import PartnerApiKeys from "@/pages/partner/PartnerApiKeys";
import PartnerUsers from "@/pages/partner/PartnerUsers";
import PartnerSecurity from "@/pages/partner/PartnerSecurity";
import PartnerTrustCenter from "@/pages/partner/PartnerTrustCenter";
import PartnerWebhooks from "@/pages/partner/PartnerWebhooks";
import PartnerOAuth from "@/pages/partner/PartnerOAuth";
import PartnerAnalytics from "@/pages/partner/PartnerAnalytics";
import PartnerHealth from "@/pages/partner/PartnerHealth";
import PartnerNotifications from "@/pages/partner/PartnerNotifications";
import PartnerReports from "@/pages/partner/PartnerReports";
import CommunityIntelligence from "@/pages/analytics/CommunityIntelligence";
import ResourceDesertDetector from "@/pages/analytics/ResourceDesertDetector";
import FunderDashboard from "@/pages/analytics/FunderDashboard";
import AlertsCenter from "@/pages/analytics/AlertsCenter";
import ExecutiveReports from "@/pages/analytics/ExecutiveReports";
import SecurityCenter from "@/pages/admin/SecurityCenter";
import SecurityLifecycle from "@/pages/admin/SecurityLifecycle";
import PartnerApplicationsAdmin from "@/pages/admin/PartnerApplicationsAdmin";
import PublicPartnerApplyEnterprise from "@/pages/PublicPartnerApplyEnterprise";
import PartnerApplicationStatus from "@/pages/PartnerApplicationStatus";
import ExecutiveOperations from "@/pages/executive/ExecutiveOperations";
import ExecutiveNotificationCenter from "@/pages/executive/ExecutiveNotificationCenter";
import AccessDenied from "@/pages/AccessDenied";
// HC-EPIC-004 Sprint 1-B — Community Partner Portal (safe-disabled-by-default backend)
import CommunityPartnerActivate from "@/pages/community-partner-portal/Activate";
import CommunityPartnerPortalUsers from "@/pages/community-partner-portal/Users";
import AdminCommunityPartnerOrganizations from "@/pages/admin/AdminCommunityPartnerOrganizations";
import AdminCommunityPartnerOrganizationDetail from "@/pages/admin/AdminCommunityPartnerOrganizationDetail";
import AdminCommunityPartnerUsers from "@/pages/admin/AdminCommunityPartnerUsers";

const Wrapped = ({ children, module, permission }) => (
  <ProtectedRoute requireModule={module} requirePermission={permission}>
    <Layout>{children}</Layout>
  </ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/impact" element={<Impact />} />
            <Route path="/help" element={<PublicHelp />} />
            <Route path="/refer" element={<PublicRefer />} />
            {/* Iter 78 — Public partner application routes (emergency route separation).
             *   /partner/apply             → Community Resource Directory application
             *   /partner/apply-integrations → Integration Partner application
             *   Legacy /partner/apply-community + /partner/apply-enterprise redirect below.
             */}
            <Route path="/partner/apply" element={<PublicPartnerApply />} />
            <Route path="/partner/apply-integrations" element={<PublicPartnerApplyEnterprise />} />
            <Route path="/partner-recovery/self-lockdown" element={<PublicPartnerLockdown />} />
            <Route path="/partner-portal/set-password" element={<PartnerSetPassword />} />
            <Route path="/partner/apply-community" element={<Navigate to="/partner/apply" replace />} />
            <Route path="/partner/status/:publicRef" element={<PartnerApplicationStatus />} />
            <Route path="/developer-portal" element={<DeveloperPortal />} />
            <Route path="/trust-center" element={<TrustCenter />} />
            <Route path="/trust" element={<Navigate to="/trust-center" replace />} />
            <Route path="/hcwi" element={<PublicAssessment />} />
            <Route path="/hcwi/contact" element={<PublicContactLead />} />
            <Route path="/a/:slug" element={<PublicAssessment />} />
            <Route path="/a/:slug/contact" element={<PublicContactLead />} />
            <Route path="/volunteer/login" element={<VolunteerLogin />} />
            <Route path="/volunteer/signup" element={<VolunteerSignup />} />
            <Route path="/volunteer/accept" element={<VolunteerAcceptInvite />} />
            <Route path="/volunteer" element={<VolunteerLayout />}>
              <Route index element={<VolunteerHome />} />
              <Route path="events" element={<VolunteerEvents />} />
              <Route path="hours" element={<VolunteerHours />} />
              <Route path="resources" element={<VolunteerResources />} />
            </Route>
            <Route path="/portal/login" element={<PortalLogin />} />
            <Route path="/portal/expired" element={<PortalExpired />} />
            <Route path="/portal" element={<PortalLayout />}>
              <Route index element={<PortalHome />} />
              <Route path="assessment" element={<PortalAssessment />} />
              <Route path="appointments" element={<PortalAppointments />} />
              <Route path="request-help" element={<PortalRequestHelp />} />
            </Route>
            <Route path="/partner/login" element={<PartnerLogin />} />
            <Route path="/partner/accept-invite" element={<PartnerAcceptInvite />} />
            <Route path="/partner/portal" element={<PartnerPortalLayout />}>
              <Route index element={<PartnerOverview />} />
              <Route path="health" element={<PartnerHealth />} />
              <Route path="analytics" element={<PartnerAnalytics />} />
              <Route path="api-keys" element={<PartnerApiKeys />} />
              <Route path="oauth" element={<PartnerOAuth />} />
              <Route path="webhooks" element={<PartnerWebhooks />} />
              <Route path="notifications" element={<PartnerNotifications />} />
              <Route path="reports" element={<PartnerReports />} />
              <Route path="profile" element={<PartnerProfile />} />
              <Route path="users" element={<PartnerUsers />} />
              <Route path="security" element={<PartnerSecurity />} />
              <Route path="trust-center" element={<PartnerTrustCenter />} />
            </Route>
            {/* --------------------------------------------------------------
             * Authenticated staff pages. Every route below is gated by the
             * module/permission a user must hold to open it — the sidebar
             * uses the same `canSeeModule()` check, so a page URL typed
             * directly into the address bar will redirect to `/` with a
             * toast when the user isn't allowed. Iter 76.8.
             * ------------------------------------------------------------ */}
            <Route path="/" element={<Wrapped permission="dashboard.home.view"><Dashboard /></Wrapped>} />
            <Route path="/care-seekers" element={<Wrapped module="care_seekers"><CareSeekers /></Wrapped>} />
            <Route path="/care-seekers/:id" element={<Wrapped module="care_seekers"><CareSeekerDetail /></Wrapped>} />
            <Route path="/intake" element={<Wrapped module="intake"><AnchorIntake /></Wrapped>} />
            <Route path="/notes" element={<Wrapped module="notes"><WellnessNotes /></Wrapped>} />
            <Route path="/referrals" element={<Wrapped module="referrals"><Referrals /></Wrapped>} />
            <Route path="/resources" element={<Wrapped module="resources"><Resources /></Wrapped>} />
            <Route path="/outreach" element={<Wrapped module="outreach"><Outreach /></Wrapped>} />
            <Route path="/maternal" element={<Wrapped module="maternal"><MaternalWellness /></Wrapped>} />
            <Route path="/tasks" element={<Wrapped module="tasks"><Tasks /></Wrapped>} />
            <Route path="/appointments" element={<Wrapped module="appointments"><Appointments /></Wrapped>} />
            <Route path="/training" element={<Wrapped module="training"><Training /></Wrapped>} />
            <Route path="/integrations" element={<Wrapped module="integrations"><Integrations /></Wrapped>} />
            <Route path="/document-templates" element={<Wrapped module="document_templates"><DocumentTemplates /></Wrapped>} />
            <Route path="/tech-support" element={<Wrapped module="tickets"><TechSupport /></Wrapped>} />
            <Route path="/cs/:displayId" element={<Wrapped module="care_seekers"><CareSeekerDirectLink /></Wrapped>} />
            <Route path="/reports" element={<Wrapped permission="dashboard.reports.view"><Reports /></Wrapped>} />
            <Route path="/reports/geo-gap" element={<Wrapped module="reports"><GeoGap /></Wrapped>} />
            <Route path="/reports/assessments" element={<Wrapped module="reports"><AdminAssessments /></Wrapped>} />
            <Route path="/analytics/community" element={<Wrapped module="community_intel"><CommunityIntelligence /></Wrapped>} />
            <Route path="/analytics/resource-desert" element={<Wrapped module="community_intel"><ResourceDesertDetector /></Wrapped>} />
            <Route path="/analytics/funder-dashboard" element={<Wrapped permission="dashboard.funder.view"><FunderDashboard /></Wrapped>} />
            <Route path="/analytics/alerts" element={<Wrapped module="community_intel"><AlertsCenter /></Wrapped>} />
            <Route path="/analytics/reports" element={<Wrapped module="reports"><ExecutiveReports /></Wrapped>} />
            <Route path="/admin/security-center" element={<Wrapped module="security_center"><SecurityCenter /></Wrapped>} />
            <Route path="/executive" element={<Wrapped permission="dashboard.executive_ops.view"><ExecutiveOperations /></Wrapped>} />
            <Route path="/executive-operations" element={<Wrapped permission="dashboard.executive_ops.view"><ExecutiveOperations /></Wrapped>} />
            <Route path="/users" element={<Wrapped module="users"><Users /></Wrapped>} />
            <Route path="/users/roles" element={<Wrapped module="roles"><AdminRoles /></Wrapped>} />
            <Route path="/admin/retention" element={<Wrapped module="retention"><AdminRetention /></Wrapped>} />
            <Route path="/admin/maintenance" element={<Wrapped module="maintenance"><AdminMaintenance /></Wrapped>} />
            <Route path="/admin/architecture-docs" element={<Wrapped module="maintenance"><ArchitectureDocs /></Wrapped>} />
            <Route path="/admin/compliance" element={<Wrapped module="compliance"><AdminCompliance /></Wrapped>} />
            <Route path="/admin/regulatory" element={<Wrapped module="compliance"><AdminRegulatory /></Wrapped>} />
            <Route path="/admin/evidence" element={<Wrapped module="compliance"><AdminEvidence /></Wrapped>} />
            <Route path="/admin/compliance-dashboard" element={<Wrapped permission="dashboard.compliance.view"><AdminExecutiveDashboard /></Wrapped>} />
            <Route path="/admin/partners" element={<Wrapped module="governance_keys"><AdminPartners /></Wrapped>} />
            <Route path="/admin/partners/:partnerId/recovery" element={<Wrapped module="partner_recovery"><AdminPartnerRecovery /></Wrapped>} />
            <Route path="/admin/partners/:partnerId/onboarding-wizard" element={<Wrapped module="governance_keys"><PartnerOnboardingWizard /></Wrapped>} />
            <Route path="/admin/trust-center" element={<Wrapped module="governance_keys"><AdminTrustCenter /></Wrapped>} />
            <Route path="/admin/backup-dr" element={<Wrapped module="backup_dr"><AdminBackupDisasterRecovery /></Wrapped>} />
            <Route path="/admin/legal-holds" element={<Wrapped module="legal_holds"><AdminLegalHolds /></Wrapped>} />
            <Route path="/admin/exceptions" element={<Wrapped module="exceptions"><AdminExceptions /></Wrapped>} />
            <Route path="/admin/sso-tenants" element={<Wrapped module="security_center"><AdminSsoTenants /></Wrapped>} />
            <Route path="/identity-security" element={<Wrapped module="security_center"><IdentitySecurity /></Wrapped>} />
            <Route path="/admin/security-lifecycle" element={<Wrapped module="security_center"><SecurityLifecycle /></Wrapped>} />
            <Route path="/admin/email-infrastructure" element={<Wrapped module="email_infra"><AdminEmailDelivery /></Wrapped>} />
            <Route path="/admin/email-templates" element={<Wrapped module="email_infra"><AdminEmailTemplateManager /></Wrapped>} />
            <Route path="/admin/change-history" element={<Wrapped module="change_history"><AdminChangeHistory /></Wrapped>} />
            <Route path="/executive/operations" element={<Wrapped permission="dashboard.executive_ops.view"><ExecutiveOperationsCenter /></Wrapped>} />
            <Route path="/executive/notifications" element={<Wrapped permission="dashboard.executive_notifications.view"><ExecutiveNotificationCenter /></Wrapped>} />
            <Route path="/admin/partner-applications" element={<Wrapped module="governance_keys"><PartnerApplicationsAdmin /></Wrapped>} />
            <Route path="/admin/partner-applications/:id" element={<Wrapped module="governance_keys"><PartnerApplicationsAdmin /></Wrapped>} />
            {/* --------------------------------------------------------------
             * HC-EPIC-004 · Sprint 1-B · Community Partner Portal
             *   - `/community-partner-portal/activate` — anonymous activation
             *     (invitation token from URL). Own auth stack; does not use
             *     the staff `ProtectedRoute` layer.
             *   - `/community-partner-portal/users` — own-org member management
             *     for an active Community Partner Organization Administrator.
             *     Also outside the staff `ProtectedRoute` layer — the page
             *     itself checks its per-tab portal token and shows a
             *     "session ended" state on 401.
             *   - `/admin/community-partner-organizations*` and
             *     `/admin/community-partner-users` — HarborWell staff pages.
             *     Gated with `permission="community_partner_organizations.view"`
             *     / `community_partner_users.administer` so a staff user
             *     without those keys cannot open them.
             * ----------------------------------------------------------- */}
            <Route path="/community-partner-portal/activate" element={<CommunityPartnerActivate />} />
            <Route path="/community-partner-portal/users" element={<CommunityPartnerPortalUsers />} />
            <Route path="/admin/community-partner-organizations"
                   element={<Wrapped permission="community_partner_organizations.view"><AdminCommunityPartnerOrganizations /></Wrapped>} />
            <Route path="/admin/community-partner-organizations/:id"
                   element={<Wrapped permission="community_partner_organizations.view"><AdminCommunityPartnerOrganizationDetail /></Wrapped>} />
            <Route path="/admin/community-partner-users"
                   element={<Wrapped permission="community_partner_users.administer"><AdminCommunityPartnerUsers /></Wrapped>} />
            <Route path="/partner/apply-enterprise" element={<Navigate to="/partner/apply-integrations" replace />} />
            <Route path="/admin/governance-keys" element={<Wrapped module="governance_keys"><AdminGovernanceKeys /></Wrapped>} />
            <Route path="/admin/uat" element={<Wrapped module="release_docs"><AdminUAT /></Wrapped>} />
            <Route path="/team/caseload" element={<Wrapped module="users"><TeamCaseload /></Wrapped>} />
            <Route path="/audit" element={<Wrapped module="audit"><AuditLog /></Wrapped>} />
            <Route path="/timesheets" element={<Wrapped module="timesheets"><Timesheets /></Wrapped>} />
            <Route path="/recently-deleted" element={<Wrapped module="recently_deleted"><RecentlyDeleted /></Wrapped>} />
            <Route path="/admin/partner-submissions" element={<Wrapped module="partner_submissions"><PartnerSubmissions /></Wrapped>} />
            <Route path="/volunteers" element={<Wrapped module="volunteers_admin"><AdminVolunteers /></Wrapped>} />
            <Route path="/field-checkins" element={<Wrapped module="field_checkins_admin"><AdminFieldCheckins /></Wrapped>} />
            <Route path="/inbox" element={<Wrapped module="inbox"><SmartInbox /></Wrapped>} />
            <Route path="/my-account" element={<Wrapped><MyAccount /></Wrapped>} />
            <Route path="/access-denied" element={<Wrapped><AccessDenied /></Wrapped>} />
          </Routes>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
